import styled from 'styled-components';

const PageContainer = styled.div`
  width: 100%;
  min-width: 0;
  padding: 25px;
  box-sizing: border-box;

  .ant-table-wrapper {
    width: 100%;
    max-width: 100%;
    margin-top: 20px;
    overflow-x: auto;
  }

  .ant-card-body {
    width: 100%;
    min-width: 0;
  }

  ul {
    padding-inline-start: 10px;
  }
  .float-right {
    float: right;
  }

  @media (max-width: 767px) {
    padding: 16px;

    .ant-card-head,
    .ant-card-body {
      padding-right: 16px;
      padding-left: 16px;
    }
  }
`;

const ActionRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  justify-content: flex-end;
  align-items: center;
`;

const Space = styled.div`
  margin: ${({ vertical = 10, horizontal = 10 }) => `${vertical}px ${horizontal}px`};
`;

const PageWrapper = styled.div`
  width: 100%;
  min-width: 0;
  padding: 25px;
  box-sizing: border-box;
  background-color: #fff;
  font-family: 'SF Display Regular';

  @media (max-width: 767px) {
    padding: 16px;
  }
`;

export { PageContainer, ActionRow, Space, PageWrapper };
